import $ from "jquery";

const homepageHero = () => {
    const init = () => {
        execute()
    }

    const execute = () => {
        const el = {
            main: '.mi-typing-animation .elementor-headline-dynamic-text',
            heading: 'js-text-gradient .elementor-heading-title'
        }

        const nodes = $(el.main);
        if (nodes.length === 0) return;

        const heading = $(el.heading).html();
        $(el.heading).html(heading.split("&nbsp;&nbsp;")[0]);

        nodes.each((index, node) => {
            const observer = new MutationObserver((mutationsList) => {
                mutationsList.forEach((mutation) => {
                    if (mutation.type === 'attributes' && $(node).hasClass('elementor-headline-text-active')) {
                        $(el.heading).html(heading.split("&nbsp;&nbsp;")[index]);
                    }
                });
            });

            observer.observe(node, {
                attributes: true, // Listen for attribute changes
                attributeFilter: ['class'] // Only observe changes to the 'class' attribute
            });
        });

    }
    // init()
}

try {
    homepageHero()
} catch (error) {
    console.error('homepageHero', error)
}